import { getSharedFilters } from "../Shared/sharedFilters";
import { fetchAllNoga, fetchAllOfficeSizes, fetchOverheads } from "./data/dataFetching";
import { extractRequestBodyFromFilters, updateFilters } from "./data/dataParsing";

export const greaterRegionOrder = ["RL", "EM", "NW", "ZH", "OS", "ZS", "TI"];

export async function overrideInitialFilters(languageKey, nextAvailableFilters) {
  const allNogaCodes = await fetchAllNoga(languageKey, (err) => console.log(err));
  const allOfficeSizes = await fetchAllOfficeSizes(languageKey, (err) => console.log(err));
  nextAvailableFilters.nogaCode = nextAvailableFilters.nogaCode.map((item) => {
    const obj = allNogaCodes.data.find((e) => e.nogaCode === item);
    return { id: obj.nogaCode, value: obj.name };
  });
  nextAvailableFilters.officeSize = nextAvailableFilters.officeSize.map((item) => {
    const obj = allOfficeSizes.data.find((e) => e.id === item);
    return { id: obj.id, value: obj.name };
  });
  nextAvailableFilters.greaterRegion.sort((a, b) => greaterRegionOrder.indexOf(a) - greaterRegionOrder.indexOf(b));
}

export function mapFilters(nextAvailableFilters, overheadFilters) {
  nextAvailableFilters.nogaCode = nextAvailableFilters.nogaCode.map((item) => {
    const obj = overheadFilters.allAvailabeFilters.nogaCode.find((e) => e.id === item);
    return obj;
  });
  nextAvailableFilters.officeSize = nextAvailableFilters.officeSize.map((item) => {
    const obj = overheadFilters.allAvailabeFilters.officeSize.find((e) => e.id === item);
    return obj;
  });
  nextAvailableFilters.greaterRegion.sort((a, b) => greaterRegionOrder.indexOf(a) - greaterRegionOrder.indexOf(b));
}

export function updateOverheadPageFilters(setFilters, filterAreaState) {
  setFilters((state) => {
    let newState = { ...state, filters: filterAreaState, newest: true };
    return newState;
  });
}

export async function updateOverheadPageState(isMasterKeyValid, languageKey, overheadFilters, setOverheadFilters, setOverheadData, translate) {
  const isInitialLoad = overheadFilters.isInitialLoad;
  const requestBody = extractRequestBodyFromFilters(overheadFilters, isInitialLoad);
  let overheadData = await fetchOverheads(languageKey, requestBody, (err) => console.log(err), isMasterKeyValid);
  let { context, reportData } = overheadData.data;
  let submitedFilters = context.filters;
  let nextAvailableFilters = getSharedFilters(translate);
  // if (isInitialLoad) {
  //   await overrideInitialFilters(languageKey, nextAvailableFilters);
  // } else {
  //   mapFilters(nextAvailableFilters, overheadFilters);
  // }
  let updatedFilters = await updateFilters(
    overheadFilters,
    submitedFilters,
    nextAvailableFilters,
    isInitialLoad,
    isMasterKeyValid,
    languageKey,
    translate
  );
  setOverheadFilters(updatedFilters);
  setOverheadData(reportData);
}
